export const CREATE_ADDRESS = "CREATE_ADDRESS";
export const UPDATE_ADDRESS = "UPDATE_ADDRESS";
export const GET_ADDRESS = "GET_ADDRESS";
export const DELETE_ADDRESS = "DELETE_ADDRESS";
export const GET_ALL_ADDRESSES = "GET_ALL_ADDRESSES";
